/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Mentions_Link_Choice_SpaceInputs */



/**
* | output |
* | --- |
* | "Link the whole space" |
*
* @param {Chat_Mentions_Link_Choice_SpaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_mentions_link_choice_space = /** @type {((inputs?: Chat_Mentions_Link_Choice_SpaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Mentions_Link_Choice_SpaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesamten Space verknüpfen")
	return /** @type {LocalizedString} */ ("Link the whole space")
});